import type { HistoryConversation } from "./build-history-conversations";

const parseDate = (value: string): Date | null => {
	const d = new Date(value);
	return Number.isNaN(d.getTime()) ? null : d;
};

const sortDesc = (items: HistoryConversation[]) =>
	items.slice().sort((a, b) => {
		const da = parseDate(a.order_at)?.getTime() ?? 0;
		const db = parseDate(b.order_at)?.getTime() ?? 0;
		return db - da;
	});

const filterByRange = (
	conversations: HistoryConversation[] = [],
	predicate: (d: Date) => boolean,
): HistoryConversation[] => {
	const result = conversations.filter((c) => {
		const d = parseDate(c.order_at);
		return d !== null && predicate(d);
	});
	return sortDesc(result);
};

export const filterConversationsByToday = (
	conversations: HistoryConversation[] = [],
): HistoryConversation[] => {
	const now = new Date();
	const startOfToday = new Date(
		now.getFullYear(),
		now.getMonth(),
		now.getDate(),
	);
	return filterByRange(
		conversations,
		(d) => d.getTime() >= startOfToday.getTime(),
	);
};

export const filterConversationsByYesterday = (
	conversations: HistoryConversation[] = [],
): HistoryConversation[] => {
	const now = new Date();
	const startOfToday = new Date(
		now.getFullYear(),
		now.getMonth(),
		now.getDate(),
	);
	const startOfYesterday = new Date(
		startOfToday.getTime() - 24 * 60 * 60 * 1000,
	);
	return filterByRange(
		conversations,
		(d) =>
			d.getTime() >= startOfYesterday.getTime() &&
			d.getTime() < startOfToday.getTime(),
	);
};

export const filterConversationsBySevenDays = (
	conversations: HistoryConversation[] = [],
): HistoryConversation[] => {
	const now = new Date();
	const startOfToday = new Date(
		now.getFullYear(),
		now.getMonth(),
		now.getDate(),
	);
	const startOfYesterday = new Date(
		startOfToday.getTime() - 24 * 60 * 60 * 1000,
	);
	const startOfSevenDaysAgo = new Date(
		startOfToday.getTime() - 7 * 24 * 60 * 60 * 1000,
	);
	return filterByRange(
		conversations,
		(d) =>
			d.getTime() >= startOfSevenDaysAgo.getTime() &&
			d.getTime() < startOfYesterday.getTime(),
	);
};

export const filterConversationsByOlderThatSevenDays = (
	conversations: HistoryConversation[] = [],
): HistoryConversation[] => {
	const now = new Date();
	const startOfToday = new Date(
		now.getFullYear(),
		now.getMonth(),
		now.getDate(),
	);
	const startOfSevenDaysAgo = new Date(
		startOfToday.getTime() - 7 * 24 * 60 * 60 * 1000,
	);
	return filterByRange(
		conversations,
		(d) => d.getTime() < startOfSevenDaysAgo.getTime(),
	);
};
